import { Box, Skeleton, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { ConflictConceptCard } from './ConflictConceptCard';
import { useConflictTab } from './useConflictTab';

export const ConflictTab = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const {
    conflictsInConcepts,
    conflictsLoading,
    setAllConceptsExpanded,
    clearAllConceptsExpanded,
  } = useConflictTab();

  if (conflictsLoading) {
    return <Skeleton variant="rectangular" height={100} />;
  }
  if (conflictsInConcepts && conflictsInConcepts.length === 0) {
    return (
      <Box>
        <Typography variant="h6">
          {formatMessage({ id: 'supervisorReview.conflictTab.noConflictsPending' })}
        </Typography>
      </Box>
    );
  }
  return (
    <Box>
      <Box sx={{ display: 'flex', gap: theme.spacing(4), cursor: 'pointer' }}>
        <Typography
          onClick={setAllConceptsExpanded}
          variant="body1"
          sx={{ color: theme.palette.primary.main, fontWeight: '400' }}
        >
          {formatMessage({ id: 'workspaceCommon.annotations.expandAllButton' })}
        </Typography>
        <Typography
          onClick={clearAllConceptsExpanded}
          variant="body1"
          sx={{ color: theme.palette.primary.main, fontWeight: '400' }}
        >
          {formatMessage({ id: 'workspaceCommon.annotations.collapseAllButton' })}
        </Typography>
      </Box>
      {conflictsInConcepts &&
        conflictsInConcepts.map((conflictInConcept) => (
          <Box key={conflictInConcept.conceptId}>
            <ConflictConceptCard conflictInConcept={conflictInConcept} />
          </Box>
        ))}
    </Box>
  );
};
